import api from '@/api';
import { useQuery } from '@tanstack/vue-query';

type FeatureFlag = {
  uuid: string;
  name: string;
  error?: string;
  is_active: boolean;
  is_enabled: boolean;
};

//-- Check for feature flags
function getFeatureFlag(feature_name: string, scope: string = 'api') {
  return api<FeatureFlag>({
    method: 'GET',
    url: `/feature-flag/${feature_name}?scope=${scope}`,
  });
}

export function useFeatureFlag(feature_name: string, scope: string = 'api') {
  return useQuery({
    queryKey: ['feature-flag', feature_name, scope],
    queryFn: () => getFeatureFlag(feature_name, scope),
  });
}
